import React from 'react';

export const IdentNumber = ({ value, record }) => ((record.careProvider) ? (
  <>
    {record.careProvider.identNumber}
    {(record.careProvider.destinationKey) ? <><br/>{`(${record.careProvider.destinationKey})`}</> : ''}
  </>
  ) : <i>---</i>
);
